import React from 'react'
import { Alert } from '@sainsburys-tech/bolt'

const AlertWrapper = props => {
  const { messageList = [] } = props
  const messages = messageList.map((message, index) => (
    <span key={index} data-test='alert-message'>
      {message}
      <br />
    </span>
  ))

  return (
    <Alert kind='error' isCloseable={false}>
      <div>{messages}</div>
    </Alert>
  )
}

export default AlertWrapper
